export default __webpack_public_path__ + "static/media/tabcash.eeaaa8fd.png";